import type { ErrorLogger } from 'tradera/utils/logger-type';
import { isServer } from 'tradera/utils/nextjs';
import { logger } from 'tradera/legacy/static/packages/logger';
import { isDev } from 'tradera/utils/environment';

const backendLoggerPromise = (async () => {
    if (isServer) {
        return await import('@tradera-internal/infrastructure-logging');
    }
    return null;
})();

export const createLogger = (name: string): ErrorLogger => {
    const loggerPromise = (async (): Promise<ErrorLogger> => {
        if (isServer) {
            const { Logger } = (await backendLoggerPromise) as {
                Logger: new (name: string) => ErrorLogger;
            };
            return Logger
                ? new Logger(name)
                : {
                      error: (message, context, error) => {
                          console.error(error, message, context);
                          if (isDev()) {
                              throw new Error(
                                  'Infrastructure logger not found',
                              );
                          }
                      },
                  };
        }
        return {
            error: async (message, context, error) => {
                return logger(error || message, {
                    contexts: {
                        isomorphicLogger: {
                            errorMessage: message,
                            ...(context || {}),
                        },
                    },
                });
            },
        };
    })();

    return {
        error: async (message, context, error) => {
            const logger = await loggerPromise;
            return logger.error(message, context, error);
        },
    };
};
